/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Pressable, Text, Icon, Image } from '@components/atoms'
import { AppBar as MuiAppBar, styled, AppBarProps as MuiAppBarProps } from '@mui/material'
import logoPng from '@public/images/logo/logo_black.png'
import logoWordingPng from '@public/images/logo/logo_wording.png'

import { useAppSelector, useAppDispatch, configActions } from '@redux/index'
import { useNavigate } from 'react-router-dom'
import { HomeNavMenuType } from '@redux/types'
import { pink } from '@mui/material/colors'

interface AppBarPropType extends MuiAppBarProps {
	open: boolean
}

interface PropsType {
	style?: React.CSSProperties
	menuList: HomeNavMenuType[]
}

export const HomeNav = (props: PropsType): JSX.Element => {
	const { menuList } = props
	// hook
	const navigate = useNavigate()

	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const isHomeOpenDrawer: boolean = useAppSelector(state => state.config.isHomeOpenDrawer)

	const backgroundColor = '#fff'

	const HEADER_OFFSET = 80 // 5rem 정도

	const scrollToSection = (id: string) => {
		const el = document.getElementById(id)
		if (!el) return

		const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET

		window.scrollTo({
			top: y,
			behavior: 'smooth',
		})
	}

	const onMenuTogglePress = () => {
		reduxDispatch(configActions.IS_HOME_OPEN_DRAWER(!isHomeOpenDrawer))
	}

	const AppBar = styled(MuiAppBar, {
		shouldForwardProp: prop => prop !== 'open',
	})<AppBarPropType>(({ theme, open }) => ({}))

	return (
		<AppBar
			position="fixed"
			color="transparent"
			className="appBar"
			css={[
				style,
				{
					backgroundColor: backgroundColor,
				},
				{ ...props.style },
			]}
			elevation={0}
			open={false}
		>
			<View className="navOuter">
				<View className="navInner">
					<Pressable onClick={() => navigate('/')}>
						<View className="logoView">
							<Image
								src={logoPng}
								style={{
									height: '3rem',
									alignItems: 'flex-start',
								}}
							/>
							<Image
								src={logoWordingPng}
								style={{ width: '8rem', marginLeft: '1rem', alignItems: 'flex-start' }}
							/>
						</View>
					</Pressable>

					<View className="navMenuView">
						{menuList.map(aMenu => {
							return (
								<Pressable
									key={aMenu.id}
									className="navMenuButton"
									onClick={() => scrollToSection(aMenu.uri.replace('/', ''))}
								>
									<Text>{aMenu.title}</Text>
								</Pressable>
							)
						})}
					</View>

					{/* <View className="menuNavButtonView">
						<Pressable className="menuNavButton" onClick={onMenuTogglePress}>
							<Icon name="menu" className="menuNavButtonIcon" />
						</Pressable>
					</View> */}
				</View>
			</View>
		</AppBar>
	)
}

const style = css({
	position: 'fixed',
	zIndex: 5,
	height: '5rem',

	'.topEventView': {
		width: '100%',
		height: '5rem',
		background: pink['A400'],
		color: '#FFF',

		'.topEventButton': {
			width: '100%',
			height: '100%',
			color: '#FFF',

			'.h1': {
				margin: 0,
			},
		},
	},

	'.navOuter': {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',

		'.navInner': {
			display: 'flex',
			justifyContent: 'flex-start',

			'.logoView': {
				display: 'flex',
				height: '4.8rem',
				marginLeft: '1rem',
				alignItems: 'center',
			},

			'.navMenuView': {
				position: 'absolute',
				display: 'flex',
				height: '100%',
				right: '10rem',

				'.navMenuButton': {
					height: '4.8rem',
					width: 'fit-content',
					paddingRight: '2rem',
					paddingLeft: '2rem',
				},
			},
		},

		'.menuNavButtonView': {
			position: 'absolute',
			display: 'none',
			right: '1rem',
			height: '5rem',
			width: '8rem',

			'.menuNavButton': {
				height: '100%',
				width: '100%',

				'.menuNavButtonIcon': {
					fontSize: '36px',
				},
			},
		},
	},

	'@media (max-width: 890px)': {
		'.navOuter': {
			'.navInner': {
				'.navMenuView': {
					display: 'none',
				},
				'.menuNavButtonView': {
					display: 'flex',

					'.menuNavButton': {
						width: '4rem',
					},
				},
			},
		},
	},
})
